import { useState } from "react";
import { PageMain } from "components/molecules";
import { PageRichHeader } from "components/molecules/PageHeader/PageRichHeader";
import { MultiSelect, IDropdownOption } from "components/atoms";
import { useTrainersOptions } from "api/hooks";
import { TRAINER_LECTURE_CONFIRMATION_STATUS } from "api/trainers/trainerLectureConfirmationsApi";
import { TrainerLectureConfirmationsTable } from "./TrainerLectureConfirmationsTable";

const STATUS_OPTIONS: IDropdownOption[] = [
  { value: TRAINER_LECTURE_CONFIRMATION_STATUS.NOT_REQUESTED, label: "Niepotwierdzone" },
  { value: TRAINER_LECTURE_CONFIRMATION_STATUS.PENDING, label: "Oczekuje" },
  { value: TRAINER_LECTURE_CONFIRMATION_STATUS.CONFIRMED, label: "Potwierdzone" },
];

export const TrainerLectureConfirmationsPage = () => {
  const [trainerId, setTrainerId] = useState<number | undefined>(undefined);
  const [status, setStatus] = useState<string | undefined>(undefined);
  const [dateFrom, setDateFrom] = useState<string>("");
  const [dateTo, setDateTo] = useState<string>("");
  const { isLoading: loadingTrainers, options: trainersOptions } = useTrainersOptions();

  const onTrainerChange = (selected: IDropdownOption[]) => {
    setTrainerId(selected.length > 0 ? Number(selected[0].value) : undefined);
  };

  const onStatusChange = (selected: IDropdownOption[]) => {
    setStatus(selected.length > 0 ? String(selected[0].value) : undefined);
  };

  return (
    <PageMain>
      <PageRichHeader header="Potwierdzenia obecności trenerów">
        <></>
      </PageRichHeader>
      <div className="flex flex-wrap items-center gap-2 mb-4">
        <MultiSelect
          label="Trener"
          name="trainer"
          isLoading={loadingTrainers}
          options={trainersOptions}
          onChange={onTrainerChange}
          className="w-full sm:w-auto sm:min-w-[18rem]"
        />
        <MultiSelect
          label="Status"
          name="status"
          options={STATUS_OPTIONS}
          onChange={onStatusChange}
          className="w-full sm:w-auto sm:min-w-[14rem]"
        />
        <div className="flex w-full flex-wrap items-center gap-2 sm:w-auto">
          <label className="text-sm text-slate-500 dark:text-slate-400">Od</label>
          <input
            type="date"
            value={dateFrom}
            onChange={(e) => setDateFrom(e.target.value)}
            className="border rounded px-2 py-1.5 text-sm min-w-0 flex-1 sm:flex-none dark:bg-slate-800 dark:border-slate-600"
          />
          <label className="text-sm text-slate-500 dark:text-slate-400">Do</label>
          <input
            type="date"
            value={dateTo}
            onChange={(e) => setDateTo(e.target.value)}
            className="border rounded px-2 py-1.5 text-sm min-w-0 flex-1 sm:flex-none dark:bg-slate-800 dark:border-slate-600"
          />
        </div>
      </div>
      <TrainerLectureConfirmationsTable
        trainerId={trainerId}
        status={status}
        dateFrom={dateFrom || undefined}
        dateTo={dateTo || undefined}
      />
    </PageMain>
  );
};
